import log from "../utils/log";
import EEN from "../utils/een_media_player";

// Many thanks to Mark Cotton - who did a bunch of documentation for how to do this stuff
// https://een.cloud/article-31.html
export class BikehubVideoPlayer {
  init() {
    var flvjs = EEN.MediaPlayer.flvjs;
    if (!flvjs.isSupported()) {
      $("#errorMessage").prepend(
        "<h1 class='text-danger mb-5 mt-5'>Video not supported by this browser</h1>"
      );
      $("#errorMessage").collapse("show");
      return;
    }
    // Initialize stuff
    if (window.videoPlayerConfig) {
      this.configureAndStartVideo(window.videoPlayerConfig);
    } else {
      return this.fetchCameraConfig();
    }
  }

  configureAndStartVideo(opts) {
    window.authKey = opts.authKey;
    window.eenDomain = opts.eenDomain;
    window.accountId = opts.accountId;
    window.cameraEEIds = opts.cameraEEIds;

    $("#videoPlayer").collapse("show");

    if ($("#videoPlayer").attr("data-kind") == "video") {
      opts.cameraIds.forEach(i =>
        this.loadVideoPlayer(i, opts.startTime, opts.endTime)
      );
    } else {
      this.loadImagePlayer();
    }
    $("#loadingSpinner").collapse("hide");
  }

  fetchCameraConfig() {
    // Use the current URL to fetch. The whole point of this is to load the page faster,
    // and asynchronously fetch credentials (rather than blocking) for reauth
    fetch(window.location, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(cameraConfig => {
        window.bikehubVideoPlayer.configureAndStartVideo(cameraConfig.config);
      });
  }

  loadVideoPlayer(cameraId, startTime = null, endTime = null) {
    const panelEl = document.getElementById(`videoPanel-${cameraId}`);
    const esn = panelEl.getAttribute("data-esn");

    log.debug(window.authKey, esn, window.eenDomain, startTime);

    let config = new EEN.MediaPlayer.MediaItem(esn);
    config.setAuthKey(window.authKey);
    config.setDomain(window.eenDomain);
    if (startTime) {
      log.debug(`startTime: ${startTime}`);
      config.setStartTime(startTime);
    }
    if (endTime) {
      log.debug(`endTime: ${endTime}`);
      config.setEndTime(endTime);
    }

    EEN.MediaPlayer.startPlayback(
      config,
      document.getElementById(`videoPlayer-${cameraId}`)
    );
  }

  loadImagePlayer() {
    $.getJSON("https://streamer.een.cloud", function() {
      // Build the subscription string
      let data = { cameras: {} };
      let stillLoading = {};
      window.cameraEEIds.forEach(id => {
        data.cameras[id] = { resource: ["image"] };
        stillLoading[id] = true;
      });

      log.debug(data);

      // Build the WebSocket connection URL
      const connection_url = [
        "wss://",
        window.eenDomain,
        "/api/v2/Device/",
        window.accountId,
        "/Events?A=",
        window.authKey,
      ].join("");

      // make the WebSocket connection
      window.socket = new WebSocket(connection_url);

      // when the socket opens, register the subscriptions
      window.socket.addEventListener("open", function(event) {
        console.log("socket opened");
        window.socket.send(JSON.stringify(data));
      });

      window.cameraEEIds.forEach(id => {
        // for every message received, parse the data into an object and update the image on the page
        // send an acknowledgement that you are ready for the next image
        window.socket.addEventListener("message", function(event) {
          // console.log(event.data);
          let json = JSON.parse(event.data);
          let img = document.getElementById(`image-${id}`);
          if (img && json.data[id]) {
            img.setAttribute(
              "src",
              "data:image/jpeg;base64," + json.data[id].image.image
            );
            window.socket.send('{"ack": ' + json.data[id].image.epoch + "}");

            // Hide the loading spinner, if it hasn't been hidden yet
            if (stillLoading[id]) {
              $(`#image-${id}-loading`).collapse("hide");
              stillLoading[id] = false;
            }
          }
        });
      });

      // handle the close event
      window.socket.addEventListener("close", function(event) {
        console.log("socket closed");
      });

      // handle any errors
      window.socket.addEventListener("error", function(event) {
        console.log("socket error ", event);
      });
    });
  }
}
